export default __webpack_public_path__ + "static/media/checkbox.75165623.svg";